module.exports = __webpack_public_path__ + "static/media/yahoo.c9b3dce9.jpg";